import { useMemo } from 'react';
import { useProviderStore } from 'core/store/providerStore';

export type OrgPermissions = {
  canReadDrivers: boolean;
  canManageFleet: boolean;
  canUpdateMember: boolean;
  canDeleteMember: boolean;
  canUpdateDriver: boolean;
};

export function getOrgPermissions(
  permissions: string[],
): OrgPermissions {
  return {
    canReadDrivers: permissions.includes('driver.read'),
    canManageFleet: permissions.includes('vehicle.manage'),
    canUpdateMember: permissions.includes('member.update'),
    canDeleteMember: permissions.includes('member.delete'),
    canUpdateDriver: permissions.includes('driver.update'),
  };
}

export function useOrgPermissions(orgId: string): OrgPermissions {
  const { orgMemberships } = useProviderStore();
  return useMemo(() => {
    const membership = orgMemberships.find((m) => m.orgId === orgId);
    return getOrgPermissions(membership?.permissions ?? []);
  }, [orgMemberships, orgId]);
}
